import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c(VTabs,{attrs:{"centered":""}},[_c(VTab,[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-clipboard-list")]),_vm._v("\n      Malha Logística de Distribuição\n    ")],1)],1),_c('MapaDeSeparacao',{staticClass:"px-2"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-200 px-2"},[_c('span',{staticClass:"font-13 font-weight-medium"},[_vm._v("DRP - Configuração da Malha Logística de Distribuição")])])
}]

export { render, staticRenderFns }